import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent, DialogService, IDialogConfig } from '@ra-web-tech-ui-toolkit/components';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly dialogSvc = inject(DialogService);
  private readonly dialog = inject(MatDialog);

  public dialogRef: MatDialogRef<DialogComponent>;

  showModal(config: IDialogConfig): MatDialogRef<DialogComponent> {
    const dialogConfig: IDialogConfig = {
      ...config,
    };
    this.dialogRef = this.dialogSvc.openDialog(dialogConfig);
    return this.dialogRef;
  }

  public close(): void {
    this.dialog.closeAll();
  }
}
